import { Component, Vue, State, Prop } from 'nuxt-property-decorator'

@Component
export default class Index extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Prop() item!: any
  @Prop() paramsIndex!: number

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get cardList() {
    const list = this.item.activities?.items

    if (list?.length) {
      if (this.isDesktop) {
        // desktop 最多只有五个图片
        return list.slice(0, 5)
      }

      return list
    }

    return []
  }

  get ratio() {
    return this.item?.activities?.banner_scale
  }

  get logoWidth() {
    return 145 / 4
  }

  getCardSpm(item: any, index: number) {
    const { track_info = {} } = this.item || {}
    const { FrontendTree = '' } = track_info
    const { brand_info = {} } = item || {}
    const { tags = [] } = brand_info
    const ext: any = {
      CategoryOrder: this.paramsIndex,
      FrontendTree
    }

    if (tags?.length) {
      ext.TagNameList = tags.map((tag: any) => tag.text)
    }

    return `CategoryActivityCard_LIST?oid=activity_${item.activity_id}&ext=${encodeURIComponent(
      JSON.stringify(ext)
    )}&idx=${index}&len=${this.cardList.length}`
  }

  customSendActionHouse(e: Event) {
    // 备注：这里卡片的class不能删除，否则找不到dom。不建议修改卡片class
    const target = (e.target as HTMLElement).closest('.rwd-activity-card')

    if (target) {
      setTimeout(() => this.$inhouse.track('action', target, { force: true }), 100)
    }
  }
}
